require('./_wks-define')('observable');



/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/babel-polyfill/~/core-js/modules/es7.symbol.observable.js
 ** module id = 2016
 ** module chunks = 0
 **/